import React, { useRef, useState, useEffect } from "react";
import { Stage, Layer, Line, Circle } from "react-konva";

export default function PipeDrawer({
    points,
    setPoints,
    setMultiplePipe,
    setIsPipeStage,
    activeTabIndex
}) {
    const containerRef = useRef(null);
    const [stageSize, setStageSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const resize = () => {
            if (containerRef.current) {
                const { clientWidth, clientHeight } = containerRef.current;
                setStageSize({ width: clientWidth, height: clientHeight });
            }
        };
        resize();
        const observer = new ResizeObserver(resize);
        if (containerRef.current) observer.observe(containerRef.current);
        return () => observer.disconnect();
    }, []);

    const handleStageClick = (e) => {
        const stage = e.target.getStage();
        const mousePos = stage.getPointerPosition();
        setPoints([...points, mousePos.x, mousePos.y]);
    };

    const handleCompletePipe = () => {
        if (points.length < 4) return;

        const getBoundingBox = (pts) => {
            const xs = pts.filter((_, i) => i % 2 === 0);
            const ys = pts.filter((_, i) => i % 2 === 1);
            const minX = Math.min(...xs);
            const maxX = Math.max(...xs);
            const minY = Math.min(...ys);
            const maxY = Math.max(...ys);

            
            return {
                x: minX,
                y: minY,
                width: maxX - minX,
                height: maxY - minY,
            };
        };

        const bounds = getBoundingBox(points);
        const relativePoints = points.map((val, i) =>
            i % 2 === 0 ? val - bounds.x : val - bounds.y
        );

        const newPipe = {
            deviceName: "Pipe",
            type: "Pipe",
            points: relativePoints,
            strokeColor: "green",
            width: bounds.width,
            height: bounds.height,
            tabIndex: activeTabIndex,
            x: bounds.x,
            y: bounds.y,
        };

        setMultiplePipe((prev) => [...prev, newPipe]);
        setIsPipeStage(false);
        setPoints([]);
    };

    const handleReset = () => {
        setPoints([]);
    };

    return (
        <div style={{ width: "100%", height: "100%", position: "absolute", zIndex: 100 }}>
            <div
                style={{
                    position: "fixed",
                    bottom: "2%",
                    left: "40%",
                    display: "flex",
                    gap: ".5rem",
                }}
            >
                <button
                    onClick={handleCompletePipe}
                    disabled={points.length < 4}
                    style={{
                        backgroundColor: "#2d5bff",
                        padding: ".3rem .5rem",
                        color: "#ffffff",
                        borderRadius: ".5rem",
                        border: "none",
                    }}
                >
                    Complete Pipe
                </button>
                <button
                    onClick={handleReset}
                    style={{
                        backgroundColor: "#2d5bff",
                        padding: "0.3rem 0.5rem",
                        color: "#ffffff",
                        borderRadius: ".5rem",
                        border: "none",
                    }}
                >
                    Reset
                </button>
            </div>

            <div ref={containerRef} style={{ flex: 1, width: "100%", height: "100%" }}>
                <Stage
                    width={stageSize.width}
                    height={stageSize.height}
                    onClick={handleStageClick}
                >
                    <Layer>
                        <Line
                            points={points}
                            stroke="#444"        // outer wall (dark gray)
                            strokeWidth={14}
                            lineCap="round"
                            lineJoin="round"
                        />
                        <Line
                            points={points}
                            stroke="#a8c4d9"     // inner pipe (light steel blue)
                            strokeWidth={10}
                            lineCap="round"
                            lineJoin="round"
                        />
                        {points.map((_, i) =>
                            i % 2 === 0 ? (
                                <Circle key={i} x={points[i]} y={points[i + 1]} radius={4} fill="red" />
                            ) : null
                        )}
                    </Layer>
                </Stage>
            </div>
        </div>
    );
}
